(function () {
  'use strict';
  console.info('CCH Shopify Reader v2.1.33 loaded — arrow-free flaps, corrected Gethsemane motion, faster opening, and deeper preloading');

  ensureCafeteriaAdobeKit();
  document.querySelectorAll('[data-cch-reader]').forEach(initializeReader);

  function ensureCafeteriaAdobeKit() {
    const href = 'https://use.typekit.net/yjt3ihz.css';
    if (document.querySelector('link[data-cch-cafeteria-kit], link[href="' + href + '"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.cchCafeteriaKit = 'true';
    document.head.appendChild(link);
  }

  function initializeReader(root) {
    if (!root || root.dataset.cchInitialized === 'true') return;
    root.dataset.cchInitialized = 'true';

    const screens = Array.from(root.querySelectorAll('[data-cch-screen]'));
    const languageButtons = Array.from(root.querySelectorAll('[data-cch-language]'));
    const libraryStage = root.querySelector('.cch-bookshelf');
    const stage = root.querySelector('[data-cch-stage]');
    const caption = root.querySelector('[data-cch-caption]');
    const notice = root.querySelector('[data-cch-reader-notice]');
    const positionLabel = root.querySelector('[data-cch-position]');
    const previousButton = root.querySelector('[data-cch-prev-spread]');
    const nextButton = root.querySelector('[data-cch-next-spread]');
    const playButton = root.querySelector('[data-cch-play-narration]');
    const stopCameraButton = root.querySelector('[data-cch-stop-camera]');
    const libraryScreen = root.querySelector('[data-cch-screen="library"]');
    const readerScreen = root.querySelector('[data-cch-screen="reader"]');
    const toolbar = root.querySelector('.cch-reader-toolbar');
    const returnLibraryButton = root.querySelector('[data-cch-return-library]');
    const customerLoggedIn = root.dataset.cchCustomerLoggedIn === 'true';
    const customerTags = readCustomerTags(root.dataset.cchCustomerTags);
    const portfolioAccessTag = String(root.dataset.cchPortfolioAccessTag || 'cch-portfolio-access').trim().toLowerCase();
    const loginUrl = root.dataset.cchLoginUrl || '/account/login';
    const storefrontRoot = root.dataset.cchRootUrl || '/';
    const cameraModeSelect = document.createElement('select');
    cameraModeSelect.className = 'cch-parent-settings__select cch-camera-mode-select';
    cameraModeSelect.setAttribute('aria-label', 'Camera mirror setting');
    cameraModeSelect.innerHTML = '<option value="pending">Ask when a book opens</option><option value="live">Enable camera mirrors</option><option value="fallback">Use illustrated mirrors</option><option value="off">Turn mirrors off</option>';
    const settingsLanguageSelect = document.createElement('select');
    settingsLanguageSelect.className = 'cch-parent-settings__select';
    settingsLanguageSelect.setAttribute('aria-label', 'Library language');
    settingsLanguageSelect.innerHTML = '<option value="en">English</option><option value="es">Español</option>';
    const audioModeSelect = document.createElement('select');
    audioModeSelect.className = 'cch-parent-settings__select';
    audioModeSelect.setAttribute('aria-label', 'Audio setting');
    audioModeSelect.innerHTML = '<option value="on">Audio on</option><option value="off">Audio off</option>';
    const settingsButton = document.createElement('button');
    settingsButton.type = 'button';
    settingsButton.className = 'cch-parent-settings-button';
    settingsButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19.14 12.94a7.7 7.7 0 0 0 .05-.94 7.7 7.7 0 0 0-.05-.94l2.03-1.58-1.92-3.32-2.39.96a7.2 7.2 0 0 0-1.63-.95L14.87 3h-3.84l-.36 3.17c-.58.24-1.12.56-1.63.95l-2.39-.96-1.92 3.32 2.03 1.58a7.7 7.7 0 0 0-.05.94c0 .32.02.63.05.94l-2.03 1.58 1.92 3.32 2.39-.96c.51.39 1.05.71 1.63.95l.36 3.17h3.84l.36-3.17c.58-.24 1.12-.56 1.63-.95l2.39.96 1.92-3.32-2.03-1.58ZM12.95 15.5A3.5 3.5 0 1 1 12.95 8a3.5 3.5 0 0 1 0 7.5Z" fill="currentColor"/></svg>';
    settingsButton.setAttribute('aria-expanded', 'false');
    const settingsPanel = document.createElement('div');
    settingsPanel.className = 'cch-parent-settings';
    settingsPanel.hidden = true;
    settingsPanel.setAttribute('role', 'dialog');
    settingsPanel.setAttribute('aria-modal', 'false');
    const settingsTitle = document.createElement('h3');
    const languageLabel = document.createElement('label');
    const languageLabelText = document.createElement('span');
    languageLabel.append(languageLabelText, settingsLanguageSelect);
    const cameraLabel = document.createElement('label');
    const cameraLabelText = document.createElement('span');
    cameraLabel.append(cameraLabelText, cameraModeSelect);
    const audioLabel = document.createElement('label');
    const audioLabelText = document.createElement('span');
    audioLabel.append(audioLabelText, audioModeSelect);
    const accountRow = document.createElement('div');
    accountRow.className = 'cch-parent-settings__account';
    const accountText = document.createElement('span');
    const accountLink = document.createElement('a');
    accountLink.className = 'cch-parent-settings__account-link';
    accountLink.href = loginUrl;
    accountRow.append(accountText, accountLink);
    const settingsClose = document.createElement('button');
    settingsClose.type = 'button';
    settingsClose.className = 'cch-parent-settings__close';
    settingsPanel.append(settingsTitle, languageLabel, cameraLabel, audioLabel, accountRow, settingsClose);

    const lockedPanel = document.createElement('div');
    lockedPanel.className = 'cch-locked-book-panel';
    lockedPanel.hidden = true;
    lockedPanel.setAttribute('role', 'dialog');
    lockedPanel.setAttribute('aria-modal', 'true');
    const lockedPanelCard = document.createElement('div');
    lockedPanelCard.className = 'cch-locked-book-panel__card';
    const lockedPanelTitle = document.createElement('h3');
    const lockedPanelMessage = document.createElement('p');
    const lockedPanelActions = document.createElement('div');
    lockedPanelActions.className = 'cch-locked-book-panel__actions';
    const lockedPanelLogin = document.createElement('a');
    lockedPanelLogin.className = 'cch-button cch-locked-book-panel__action';
    lockedPanelLogin.href = loginUrl;
    const lockedPanelBuy = document.createElement('a');
    lockedPanelBuy.className = 'cch-button cch-locked-book-panel__action';
    const lockedPanelClose = document.createElement('button');
    lockedPanelClose.type = 'button';
    lockedPanelClose.className = 'cch-button cch-locked-book-panel__close';
    lockedPanelActions.append(lockedPanelLogin, lockedPanelBuy, lockedPanelClose);
    lockedPanelCard.append(lockedPanelTitle, lockedPanelMessage, lockedPanelActions);
    lockedPanel.appendChild(lockedPanelCard);

    if (libraryScreen) libraryScreen.append(settingsButton, settingsPanel, lockedPanel);
    if (stopCameraButton) stopCameraButton.hidden = true;

    let language = safelyReadLanguage();
    let cameraPreference = safelyReadCameraPreference();
    let audioEnabled = safelyReadAudioPreference();
    settingsLanguageSelect.value = language;
    cameraModeSelect.value = cameraPreference;
    audioModeSelect.value = audioEnabled ? 'on' : 'off';
    let book = null;
    const libraryManifestUrl = root.dataset.cchBookUrl || '';
    let bookUrl = libraryManifestUrl;
    let spreadIndex = 0;
    let familyTimer = null;
    let narrationTimer = null;
    let narrationAudio = null;
    let narrationToken = 0;
    let hotspotAudio = null;
    let hotspotAudioSource = '';
    let hotspotAudioQueue = [];
    let pendingNarrationAfterHotspot = false;
    let narrationPausedForHotspot = false;
    let narrationUserPaused = false;
    let narrationResumeResolve = null;
    let soundEffectAudio = null;
    let cameraStream = null;
    let cameraMode = 'pending';
    let cameraChoicePanel = null;
    let leftGateResolve = null;
    let narrationWaitingForLeftFlaps = false;
    let mirrorButtons = [];
    let flapButtons = [];
    let hotspotButtons = [];
    let openedFlapIds = new Set();
    let cachedBookPromise = null;
    let pageInfoSheet = null;
    let pageInfoTimer = null;
    let lastTouchTap = 0;
    let readerControlsOverlay = null;
    let spreadRenderToken = 0;
    let backgroundPreloadToken = 0;
    const imagePreloadCache = new Map();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    installReaderPageMode();
    installToddlerReaderNavigation();

    applyLanguage(language);
    applyAudioPreference();

    if (libraryManifestUrl) {
      cachedBookPromise = fetchBook(libraryManifestUrl).then(function (manifestBook) {
        renderConfiguredLibrary(manifestBook, libraryManifestUrl);
        return manifestBook;
      });
    }

    root.addEventListener('click', handleRootClick);
    languageButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        language = button.dataset.cchLanguage || 'en';
        safelySaveLanguage(language);
        applyLanguage(language);
        if (book) renderSpread({ autoplayNarration: false });
        if (cachedBookPromise) cachedBookPromise.then(function (manifestBook) { renderConfiguredLibrary(manifestBook, libraryManifestUrl); }).catch(function () {});
      });
    });

    settingsButton.addEventListener('click', function (event) {
      event.stopPropagation();
      const opening = settingsPanel.hidden;
      settingsPanel.hidden = !opening;
      settingsButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) settingsLanguageSelect.focus({ preventScroll: true });
    });
    settingsClose.addEventListener('click', closeParentSettings);
    lockedPanelClose.addEventListener('click', closeLockedBookPanel);
    lockedPanel.addEventListener('click', function (event) {
      if (event.target === lockedPanel) closeLockedBookPanel();
    });
    lockedPanelCard.addEventListener('click', function (event) { event.stopPropagation(); });
    settingsPanel.addEventListener('click', function (event) { event.stopPropagation(); });
    root.addEventListener('click', function () { closeParentSettings(); });
    root.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeParentSettings(); });
    settingsLanguageSelect.addEventListener('change', function () {
      language = settingsLanguageSelect.value === 'es' ? 'es' : 'en';
      safelySaveLanguage(language);
      applyLanguage(language);
      if (book && root.querySelector('[data-cch-screen="reader"]')?.classList.contains('is-active')) renderSpread({ autoplayNarration: false });
      if (cachedBookPromise) cachedBookPromise.then(function (manifestBook) { renderConfiguredLibrary(manifestBook, libraryManifestUrl); }).catch(function () {});
    });
    audioModeSelect.addEventListener('change', function () {
      audioEnabled = audioModeSelect.value !== 'off';
      safelySaveAudioPreference(audioEnabled);
      applyAudioPreference();
    });

    previousButton.addEventListener('click', function () {
      if (!book || spreadIndex <= 0) return;
      moveToSpread(spreadIndex - 1, true);
    });

    nextButton.addEventListener('click', function () {
      if (!book) return;
      if (spreadIndex >= book.spreads.length - 1) {
        returnToLibrary();
        return;
      }
      moveToSpread(spreadIndex + 1, true);
    });

    playButton.addEventListener('click', function () {
      if (playButton.classList.contains('is-playing')) {
        pauseNarrationByUser();
        return;
      }
      if (playButton.classList.contains('is-paused')) {
        resumeNarrationByUser();
        return;
      }
      playCurrentNarration(true);
    });

    stopCameraButton?.addEventListener('click', function () {
      useIllustratedMirrors();
    });
    cameraModeSelect.addEventListener('change', function () {
      cameraPreference = ['live', 'fallback', 'off'].includes(cameraModeSelect.value) ? cameraModeSelect.value : 'pending';
      safelySaveCameraPreference(cameraPreference);
      stopCamera(cameraPreference === 'pending' ? 'pending' : cameraPreference);
      syncCameraModeSelect();
    });

    window.addEventListener('pagehide', stopAllMedia);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopNarration();
    });

    showScreen('house', false);

    function handleRootClick(event) {
      const navigationButton = event.target.closest('[data-cch-go]');
      if (navigationButton && root.contains(navigationButton)) {
        const target = navigationButton.dataset.cchGo;
        if (target === 'family') {
          showScreen('family', false);
        } else {
          showScreen(target, true);
        }
        return;
      }

      const lockedBookButton = event.target.closest('[data-cch-locked-book]');
      if (lockedBookButton && root.contains(lockedBookButton)) {
        openLockedBookPanel(lockedBookButton);
        return;
      }

      const openBookButton = event.target.closest('[data-cch-open-book]');
      if (openBookButton && root.contains(openBookButton)) {
        openBook(openBookButton);
        return;
      }

      const returnButton = event.target.closest('[data-cch-return-library]');
      if (returnButton && root.contains(returnButton)) returnToLibrary();
    }

    function renderConfiguredLibrary(manifestBook, manifestUrl) {
      if (!libraryStage || !manifestBook) return;
      const slots = Array.isArray(manifestBook.library?.slots) ? manifestBook.library.slots : [];
      if (!slots.length) return;

      libraryStage.classList.add('cch-bookshelf--illustrated');
      libraryStage.innerHTML = '';

      const backgroundPath = manifestBook.house?.library?.path || manifestBook.library?.background || '';
      if (backgroundPath) {
        const art = document.createElement('img');
        art.className = 'cch-bookshelf__art';
        art.src = resolveAssetForBook(backgroundPath, manifestBook, manifestUrl);
        art.alt = localizedValueForLanguage(manifestBook.house?.library?.alt, language);
        art.draggable = false;
        libraryStage.appendChild(art);
      }

      slots.forEach(function (slot, index) {
        const status = slot.status || (index === 0 ? 'available' : 'coming-soon');
        if (status === 'hidden') return;
        const title = localizedValueForLanguage(slot.title, language) || 'Book ' + (index + 1);
        const accessibleLabel = localizedValueForLanguage(slot.label, language) || title;
        const connectsManifest = !slot.bookUrl && (!slot.bookId || slot.bookId === manifestBook.id);
        const accessTag = requiredAccessTag(slot);
        const unlockedByTag = status === 'locked' && ((accessTag && customerTags.has(accessTag.toLowerCase())) || (portfolioAccessTag && customerTags.has(portfolioAccessTag)));
        const effectiveStatus = unlockedByTag ? 'available' : status;
        const available = effectiveStatus === 'available' && (Boolean(slot.bookUrl) || connectsManifest);
        const lockedAction = status === 'locked' && !unlockedByTag;
        const cover = document.createElement(available || lockedAction ? 'button' : 'div');
        cover.className = 'cch-library-cover cch-library-cover--' + effectiveStatus + (unlockedByTag ? ' cch-library-cover--unlocked' : '');
        cover.style.left = finitePercent(slot.x, 10 + (index % 3) * 26) + '%';
        cover.style.top = finitePercent(slot.y, index < 3 ? 15 : 57) + '%';
        cover.style.width = finitePercent(slot.width, 15) + '%';
        const localizedCoverAspect = positiveNumber(slot.coverAspects?.[language], positiveNumber(slot.coverAspects?.en, positiveNumber(slot.aspect, .914)));
        cover.style.aspectRatio = String(localizedCoverAspect) + ' / 1';
        cover.dataset.cchLibrarySlot = String(index);

        if (available) {
          cover.type = 'button';
          cover.dataset.cchOpenBook = 'true';
          cover.dataset.cchBookId = slot.bookId || manifestBook.id || '';
          cover.dataset.cchManifestBookId = manifestBook.id || '';
          const slotUrl = resolveBookUrl(slot.bookUrl, manifestUrl, manifestBook);
          if (slotUrl && !sameUrl(slotUrl, manifestUrl)) cover.dataset.cchBookUrl = slotUrl;
          cover.setAttribute('aria-label', accessibleLabel);
        } else if (lockedAction) {
          cover.type = 'button';
          cover.dataset.cchLockedBook = 'true';
          cover.dataset.cchLockedTitle = title;
          cover.dataset.cchProductHandle = slot.productHandle || '';
          cover.dataset.cchAccessTag = accessTag || '';
          cover.setAttribute('aria-label', accessibleLabel + '. ' + statusText(status));
        } else {
          cover.setAttribute('role', 'img');
          cover.setAttribute('aria-label', accessibleLabel + '. ' + statusText(status));
          cover.setAttribute('aria-disabled', 'true');
        }

        const coverPath = localizedValueForLanguage(slot.coverPaths, language) || slot.coverPath || '';
        if (coverPath) {
          cover.classList.add('cch-library-cover--has-image');
          cover.style.aspectRatio = 'auto';
          const image = document.createElement('img');
          image.className = 'cch-library-cover__image';
          image.src = resolveAssetForBook(coverPath, manifestBook, manifestUrl);
          image.alt = '';
          image.draggable = false;
          cover.appendChild(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'cch-library-cover__placeholder';
          placeholder.textContent = title;
          cover.appendChild(placeholder);
        }

        if (!available) {
          if (status === 'locked' || status === 'coming-soon') {
            const lock = document.createElement('span');
            lock.className = 'cch-library-cover__lock';
            lock.innerHTML = '<svg viewBox="0 0 32 36" aria-hidden="true" focusable="false"><path d="M8 15v-4C8 5.5 11.6 2 16 2s8 3.5 8 9v4" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><rect x="4" y="14" width="24" height="19" rx="5" fill="currentColor"/><circle cx="16" cy="23" r="2.5" fill="#4a382d"/></svg>';
            lock.setAttribute('aria-hidden', 'true');
            cover.appendChild(lock);
          }
          const statusLabel = document.createElement('span');
          statusLabel.className = 'cch-library-cover__status';
          statusLabel.textContent = status === 'available' && !available ? localized('Connect book', 'Conecta el libro') : statusText(status);
          statusLabel.setAttribute('aria-hidden', 'true');
          cover.appendChild(statusLabel);
        }
        libraryStage.appendChild(cover);
      });
    }

    function statusText(status) {
      if (status === 'locked') return localized('Locked', 'Bloqueado');
      if (status === 'coming-soon') return localized('In production', 'En producción');
      return status;
    }

    function readCustomerTags(rawValue) {
      if (!rawValue) return new Set();
      try {
        const parsed = JSON.parse(rawValue);
        if (Array.isArray(parsed)) return new Set(parsed.map(function (tag) { return String(tag).trim().toLowerCase(); }).filter(Boolean));
      } catch (error) {
        // Fall through to a simple delimiter list for older Liquid snippets.
      }
      return new Set(String(rawValue).split(/[|,]/).map(function (tag) { return tag.trim().toLowerCase(); }).filter(Boolean));
    }

    function normalizedAccessKey(value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function requiredAccessTag(slot) {
      if (slot?.accessTag) return String(slot.accessTag).trim();
      const key = normalizedAccessKey(slot?.productHandle || slot?.bookId || '');
      return key ? 'cch-access-' + key : '';
    }

    function productUrlForHandle(handle) {
      const cleanHandle = normalizedAccessKey(handle);
      if (!cleanHandle) return '';
      const origin = window.location.origin && window.location.origin !== 'null'
        ? window.location.origin
        : 'https://example.invalid';
      const base = new URL(storefrontRoot || '/', origin);
      return new URL('products/' + encodeURIComponent(cleanHandle), ensureTrailingSlash(base.href)).href;
    }

    function openLockedBookPanel(button) {
      closeParentSettings();
      const title = button.dataset.cchLockedTitle || localized('Locked book', 'Libro bloqueado');
      const productHandle = button.dataset.cchProductHandle || '';
      lockedPanelTitle.textContent = title;
      lockedPanelMessage.textContent = customerLoggedIn
        ? localized('This account does not have access to this book yet.', 'Esta cuenta todavía no tiene acceso a este libro.')
        : localized('Sign in with the email used to purchase the book, or open its purchase page.', 'Inicia sesión con el correo usado para comprar el libro, o abre la página de compra.');
      lockedPanelLogin.hidden = customerLoggedIn;
      lockedPanelLogin.textContent = localized('Sign in', 'Iniciar sesión');
      const purchaseUrl = productUrlForHandle(productHandle);
      lockedPanelBuy.hidden = !purchaseUrl;
      if (purchaseUrl) lockedPanelBuy.href = purchaseUrl;
      lockedPanelBuy.textContent = localized('Purchase book', 'Comprar libro');
      lockedPanelClose.textContent = localized('Close', 'Cerrar');
      lockedPanel.hidden = false;
      requestAnimationFrame(function () { lockedPanel.classList.add('is-open'); });
      lockedPanelClose.focus({ preventScroll: true });
    }

    function closeLockedBookPanel() {
      if (lockedPanel.hidden) return;
      lockedPanel.classList.remove('is-open');
      window.setTimeout(function () { lockedPanel.hidden = true; }, reducedMotion ? 0 : 180);
    }

    function localizedValueForLanguage(value, selectedLanguage) {
      if (typeof value === 'string') return value;
      if (!value || typeof value !== 'object') return '';
      return value[selectedLanguage] || value.en || value.es || '';
    }

    function finitePercent(value, fallback) {
      const number = Number(value);
      return Number.isFinite(number) ? Math.max(0, Math.min(100, number)) : fallback;
    }

    function positiveNumber(value, fallback) {
      const number = Number(value);
      return Number.isFinite(number) && number > 0 ? number : fallback;
    }

    function resolveBookUrl(value, manifestUrl, manifestBook) {
      if (!value) return manifestUrl;
      if (/^(https?:|\/\/)/i.test(value)) return value;
      const clean = String(value).replace(/^\.\//, '').replace(/^\//, '');
      const configuredBase = root.dataset.cchAssetBase || manifestBook?.assetBaseUrl || manifestBook?.baseUrl || '';
      if (configuredBase) return new URL(clean.split('/').pop(), new URL(ensureTrailingSlash(configuredBase), window.location.href)).href;
      return new URL(clean, manifestUrl || window.location.href).href;
    }

    function sameUrl(first, second) {
      try { return new URL(first, window.location.href).href === new URL(second, window.location.href).href; }
      catch (error) { return String(first || '') === String(second || ''); }
    }

    function installReaderPageMode() {
      document.documentElement.classList.add('cch-reader-page');
      if (document.body) document.body.classList.add('cch-reader-page');
    }

    function installToddlerReaderNavigation() {
      if (!toolbar || !readerScreen || !stage || !previousButton || !nextButton || !positionLabel) return;
      toolbar.classList.add('cch-reader-toolbar--toddler');

      if (returnLibraryButton) {
        returnLibraryButton.classList.add('cch-reader-library-button');
        returnLibraryButton.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="M5 7.5h7v17H5zM13.5 5h6v19.5h-6zM21 8.5h6v16h-6z" fill="currentColor"/><path d="M4 26.5h24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
      }

      const arrowGroup = document.createElement('div');
      arrowGroup.className = 'cch-reader-arrow-group';
      previousButton.classList.add('cch-reader-arrow', 'cch-reader-arrow--previous');
      nextButton.classList.add('cch-reader-arrow', 'cch-reader-arrow--next');
      previousButton.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="M19.5 7.5 11 16l8.5 8.5" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nextButton.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="m12.5 7.5 8.5 8.5-8.5 8.5" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      arrowGroup.append(previousButton, nextButton);
const isIPhone = /iPhone|iPod/.test(navigator.userAgent);

readerControlsOverlay = document.createElement('div');
readerControlsOverlay.className = isIPhone
  ? 'cch-spread-control-overlay'
  : 'cch-reader-controls-below';

readerControlsOverlay.setAttribute('aria-label', 'Book controls');

if (returnLibraryButton) {
  readerControlsOverlay.appendChild(returnLibraryButton);
}

readerControlsOverlay.appendChild(arrowGroup);

if (playButton) {
  playButton.classList.add('cch-reader-narration-button');
  
   playButton.innerHTML = `
  <span class="cch-narration-icon cch-narration-icon--play" aria-hidden="true">
    <svg viewBox="0 0 40 40" focusable="false">
      <path d="M6.5 16h6l7-6v20l-7-6h-6z" fill="currentColor"/>
      <path d="M24 14c2 1.6 3.2 3.6 3.2 6s-1.2 4.4-3.2 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
      <path d="M28.5 10.5c3.2 2.5 5 5.6 5 9.5s-1.8 7-5 9.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
    </svg>
  </span>
  <span class="cch-narration-icon cch-narration-icon--pause" aria-hidden="true">
    <svg viewBox="0 0 40 40" focusable="false">
      <rect x="11" y="9" width="6" height="22" rx="1.5" fill="currentColor"/>
      <rect x="23" y="9" width="6" height="22" rx="1.5" fill="currentColor"/>
    </svg>
  </span>
`;
  playButton.hidden = true;
  readerControlsOverlay.appendChild(playButton);
} 
if (isIPhone) {
  const iphoneTray = document.createElement('div');
  iphoneTray.className = 'cch-iphone-reader-tray';

  const iphoneTrayToggle = document.createElement('button');
  iphoneTrayToggle.type = 'button';
  iphoneTrayToggle.className = 'cch-iphone-reader-tray__toggle';
  iphoneTrayToggle.setAttribute('aria-label', 'Book controls');
  iphoneTrayToggle.setAttribute('aria-expanded', 'false');
  iphoneTrayToggle.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const iphoneTrayPanel = document.createElement('div');
  iphoneTrayPanel.className = 'cch-iphone-reader-tray__panel';

  if (returnLibraryButton) {
    iphoneTrayPanel.appendChild(returnLibraryButton);
  }

  if (playButton) {
    iphoneTrayPanel.appendChild(playButton);
  }

  iphoneTray.append(iphoneTrayToggle, iphoneTrayPanel);
  readerControlsOverlay.appendChild(iphoneTray);

iphoneTrayToggle.addEventListener('pointerdown', function (event) {
  event.preventDefault();
  event.stopPropagation();

  const isOpen = iphoneTray.classList.toggle('is-open');

  iphoneTrayToggle.setAttribute(
    'aria-expanded',
    isOpen ? 'true' : 'false'
  );
});

  root.addEventListener('pointerdown', function (event) {
    if (!iphoneTray.classList.contains('is-open')) return;
    if (iphoneTray.contains(event.target)) return;

    iphoneTray.classList.remove('is-open');
    iphoneTrayToggle.setAttribute('aria-expanded', 'false');
  });
}
const spreadFrame = stage.closest('.cch-spread-frame');

if (isIPhone && spreadFrame) {
  stage.classList.add('cch-iphone-spread');
  spreadFrame.classList.add('cch-iphone-spread-frame');
  spreadFrame.appendChild(readerControlsOverlay);
} else if (spreadFrame && spreadFrame.parentNode) {
  spreadFrame.insertAdjacentElement('afterend', readerControlsOverlay);
} else {
  readerScreen.appendChild(readerControlsOverlay);
}

      pageInfoSheet = document.createElement('div');
      pageInfoSheet.className = 'cch-page-info-sheet';
      pageInfoSheet.setAttribute('aria-hidden', 'true');
      const pageInfoInner = document.createElement('div');
      pageInfoInner.className = 'cch-page-info-sheet__inner';
      const pageInfoClose = document.createElement('button');
      pageInfoClose.type = 'button';
      pageInfoClose.className = 'cch-page-info-sheet__close';
      pageInfoClose.setAttribute('aria-label', 'Close page information');
      pageInfoClose.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
      positionLabel.classList.add('cch-page-info-sheet__position');
      pageInfoInner.append(positionLabel);
      pageInfoInner.append(pageInfoClose);
      pageInfoSheet.append(pageInfoInner);
      readerScreen.append(pageInfoSheet);

      pageInfoClose.addEventListener('click', hidePageInfo);
      stage.addEventListener('dblclick', function (event) {
        if (event.target.closest('button, a, input, select, textarea, [role="button"]')) return;
        event.preventDefault();
        togglePageInfo();
      });
      stage.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'mouse') return;
        if (event.target.closest('button, a, input, select, textarea, [role="button"]')) {
          lastTouchTap = 0;
          return;
        }
        const now = Date.now();
        if (now - lastTouchTap > 60 && now - lastTouchTap < 420) {
          event.preventDefault();
          lastTouchTap = 0;
          togglePageInfo();
        } else {
          lastTouchTap = now;
        }
      }, { passive: false });
    }

    function togglePageInfo() {
      if (!pageInfoSheet) return;
      if (pageInfoSheet.classList.contains('is-open')) hidePageInfo();
      else showPageInfo();
    }

    function showPageInfo() {
      if (!pageInfoSheet) return;
      clearTimeout(pageInfoTimer);
      pageInfoSheet.classList.add('is-open');
      pageInfoSheet.setAttribute('aria-hidden', 'false');
      pageInfoTimer = window.setTimeout(hidePageInfo, 5200);
    }

    function hidePageInfo() {
      clearTimeout(pageInfoTimer);
      if (!pageInfoSheet) return;
      pageInfoSheet.classList.remove('is-open');
      pageInfoSheet.setAttribute('aria-hidden', 'true');
    }

    function showScreen(screenName, moveFocus) {
      clearTimeout(familyTimer);
      let activeScreen = null;

      screens.forEach(function (screen) {
        const active = screen.dataset.cchScreen === screenName;
        screen.classList.remove('is-fading');
        screen.classList.toggle('is-active', active);
        screen.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) activeScreen = screen;
      });
      if (screenName !== 'reader') {
        stopNarration();
        hidePageInfo();
      }
      if (screenName !== 'library') closeLockedBookPanel();

      if (activeScreen && moveFocus !== false) {
        const focusTarget = activeScreen.querySelector('h1, h2, button');
        if (focusTarget) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
      }

      if (screenName === 'family' && activeScreen) {
        const displayTime = reducedMotion ? 900 : 2600;
        const fadeTime = reducedMotion ? 0 : 650;
        familyTimer = window.setTimeout(function () {
          activeScreen.classList.add('is-fading');
          familyTimer = window.setTimeout(function () {
            activeScreen.classList.remove('is-fading');
            showScreen('library', true);
          }, fadeTime);
        }, displayTime);
      }
    }

    async function openBook(openBookButton) {
      clearNotice();
      showNotice(localized('Loading the book…', 'Cargando el libro…'));

      try {
        const requestedUrl = openBookButton?.dataset.cchBookUrl || libraryManifestUrl;
        const requestedBookId = openBookButton?.dataset.cchBookId || '';
        if (!requestedUrl) throw new Error('No book.json URL is connected.');
        const useManifest = !openBookButton?.dataset.cchBookUrl;
        bookUrl = requestedUrl;
        book = useManifest ? await (cachedBookPromise || fetchBook(libraryManifestUrl)) : await fetchBook(requestedUrl);
        if (!book || !Array.isArray(book.spreads) || book.spreads.length === 0) {
          throw new Error('The book file does not contain any spreads.');
        }

        installBookFonts();
        spreadIndex = 0;
        cameraMode = cameraPreference === 'pending' ? 'pending' : cameraPreference;
        clearNotice();
        showScreen('reader', false);
        renderSpread({ autoplayNarration: false });
        stage.focus({ preventScroll: true });

        const hasMirrors = (book.spreads || []).some(function (spread) {
          return Array.isArray(spread.mirrors) && spread.mirrors.length > 0;
        });
        if (hasMirrors) {
          if (cameraPreference === 'live') await enableCameraMirrors();
          else if (cameraPreference === 'fallback') useIllustratedMirrors();
          else if (cameraPreference === 'off') turnCameraMirrorsOff();
          else if (book.settings?.cameraChoiceAtStart !== false) await showCameraChoice();
        }
        if (audioEnabled && book.settings?.autoplayNarration !== false) scheduleNarration(180);
      } catch (error) {
        console.error(error);
        showScreen('library', false);
        showNotice(
          localized(
            'The book could not open. Check the book.json URL in the theme editor.',
            'El libro no se pudo abrir. Revisa la dirección de book.json en el editor del tema.'
          )
        );
      }
    }

    async function fetchBook(url) {
      if (!url) throw new Error('No book.json URL is connected.');
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error('Could not load book.json.');
      return response.json();
    }

    function returnToLibrary() {
      stopAllMedia();
      showScreen('library', true);
    }
let lastSpreadMoveAt = 0;
    function moveToSpread(index, playTurnSound) {
  const now = Date.now();

  if (now - lastSpreadMoveAt < 500) return;
  lastSpreadMoveAt = now;

  if (!book || index < 0 || index >= book.spreads.length) return;

  stopNarration();

  if (playTurnSound) {
    playBookSound('pageTurn');
  }

  spreadIndex = index;

  renderSpread({
    autoplayNarration: true,
    narrationDelay: playTurnSound ? 380 : 160
  });
}

    function spreadCriticalImageSources(spread) {
      if (!spread) return [];
      const backgroundSource = localizedBackgroundSource(spread);
      const sources = [backgroundSource];
      (spread.flaps || []).forEach(function (flap) {
        sources.push(flapUsesSpreadArtwork(flap) ? backgroundSource : flap.frontImage);
      });
      return Array.from(new Set(sources.filter(Boolean).map(resolveAsset)));
    }

    function spreadDeferredImageSources(spread) {
      if (!spread) return [];
      const sources = [];
      (spread.flaps || []).forEach(function (flap) {
        sources.push(flap.insideImage, flap.revealImage);
      });
      (spread.mirrors || []).forEach(function (mirror) {
        sources.push(mirror.fallbackImage);
      });
      return Array.from(new Set(sources.filter(Boolean).map(resolveAsset)));
    }

    function preloadImage(source) {
      if (!source) return Promise.resolve();
      if (imagePreloadCache.has(source)) return imagePreloadCache.get(source);
      const promise = new Promise(function (resolve) {
        const image = new Image();
        let finished = false;
        const timer = window.setTimeout(finish, 9000);
        function finish() {
          if (finished) return;
          finished = true;
          window.clearTimeout(timer);
          resolve();
        }
        image.addEventListener('load', function () {
          if (typeof image.decode === 'function') image.decode().catch(function () {}).then(finish);
          else finish();
        }, { once: true });
        image.addEventListener('error', finish, { once: true });
        image.src = source;
        if (image.complete && image.naturalWidth > 0) {
          if (typeof image.decode === 'function') image.decode().catch(function () {}).then(finish);
          else finish();
        }
      });
      imagePreloadCache.set(source, promise);
      return promise;
    }

    function preloadSources(sources) {
      return Promise.all((sources || []).map(preloadImage));
    }

    function preloadUpcomingSpreads() {
      const remaining = (book?.spreads || []).slice(spreadIndex + 1);
      if (!remaining.length) return;
      const runToken = ++backgroundPreloadToken;
      const nextSpread = remaining[0];
      const finalInteractiveSpread = remaining.slice().reverse().find(function (candidate) {
        return (candidate.flaps || []).length > 0;
      });
      const otherSpreads = remaining.filter(function (candidate) {
        return candidate !== nextSpread && candidate !== finalInteractiveSpread;
      });

      const start = async function () {
        try {
          // The next spread is still first priority.
          await preloadSources(spreadCriticalImageSources(nextSpread));
          if (runToken !== backgroundPreloadToken) return;

          // Warm the final interactive spread early because it contains many
          // separate flap-front PNGs and was the slowest child-tested page.
          if (finalInteractiveSpread && finalInteractiveSpread !== nextSpread) {
            await preloadSources(spreadCriticalImageSources(finalInteractiveSpread));
            if (runToken !== backgroundPreloadToken) return;
          }

          // The next spread's under-flap assets are useful immediately, but do
          // not block the remaining spread-front downloads behind them.
          preloadSources(spreadDeferredImageSources(nextSpread)).catch(function () {});

          for (const candidate of otherSpreads) {
            if (runToken !== backgroundPreloadToken) return;
            await preloadSources(spreadCriticalImageSources(candidate));
          }
        } catch (error) {
          // Preloading is an enhancement; the normal guarded page load remains.
        }
      };

      window.setTimeout(start, 40);
    }

    function revealSpreadWhenReady(spread, token, cover, settings) {
      // Start the inside/reveal downloads immediately while the closed fronts
      // are being prepared. This removes most of the pause after a child taps.
      preloadSources(spreadDeferredImageSources(spread)).catch(function () {});

      preloadSources(spreadCriticalImageSources(spread)).then(function () {
        if (token !== spreadRenderToken || spread !== book?.spreads?.[spreadIndex]) return;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (token !== spreadRenderToken || spread !== book?.spreads?.[spreadIndex]) return;
            cover.classList.add('is-ready');
            stage.setAttribute('aria-busy', 'false');
            updateReaderControls();
            if (playButton) playButton.disabled = false;
            syncNarrationButton();
            window.setTimeout(function () { if (cover.isConnected) cover.remove(); }, 150);
            preloadUpcomingSpreads();
            if (settings.autoplayNarration && book.settings?.autoplayNarration !== false) {
              scheduleNarration(settings.narrationDelay || 180);
            }
          });
        });
      });
    }

    function renderSpread(options) {
      const settings = options || {};
      const spread = book.spreads[spreadIndex];
      if (!spread) return;
      const renderToken = ++spreadRenderToken;

      stopNarration();
      stage.innerHTML = '';
      stage.setAttribute('aria-busy', 'true');
      const loadingCover = document.createElement('span');
      loadingCover.className = 'cch-spread-loading-cover';
      loadingCover.setAttribute('aria-hidden', 'true');
      stage.appendChild(loadingCover);
      mirrorButtons = [];
      flapButtons = [];
      hotspotButtons = [];
      openedFlapIds = new Set();
      clearNotice();

      const background = document.createElement('img');
      background.className = 'cch-spread-bg';
      background.src = resolveAsset(localizedBackgroundSource(spread));
      background.alt = localizedValue(spread.alt);
      background.loading = 'eager';
      background.decoding = 'async';
      background.draggable = false;
      stage.appendChild(background);

      (spread.texts || []).filter(function (text) { return textPlacement(text) === 'spread'; }).forEach(function (text) {
        renderText(text, stage, textLayout(text), '');
      });
      (spread.flaps || []).forEach(renderFlap);
      (spread.texts || []).filter(function (text) { return textPlacement(text) === 'reveal'; }).forEach(renderRevealText);
      (spread.texts || []).filter(function (text) { return textPlacement(text) === 'inside'; }).forEach(renderInsideText);
      (spread.mirrors || []).forEach(renderMirror);
      (spread.hotspots || []).forEach(renderHotspot);

      caption.textContent = localizedValue(spread.caption);
      updateReaderControls();
      previousButton.disabled = true;
      nextButton.disabled = true;
      if (playButton) playButton.disabled = true;
      syncNarrationButton();
      updateCoveredMirrors();
      updateHotspotVisibility();
      revealSpreadWhenReady(spread, renderToken, loadingCover, settings);
    }

    function textPlacement(text) {
      return ['spread', 'reveal', 'inside'].includes(text?.placement) ? text.placement : 'spread';
    }

    function normalizedTextGeometry(box, fallback) {
      const base = fallback || { x: 10, y: 10, width: 35, height: 18 };
      const width = Math.max(.1, Math.min(100, Number(box?.width ?? base.width) || base.width));
      const height = Math.max(.1, Math.min(100, Number(box?.height ?? base.height) || base.height));
      return {
        x: Math.max(0, Math.min(100 - width, Number(box?.x ?? base.x) || 0)),
        y: Math.max(0, Math.min(100 - height, Number(box?.y ?? base.y) || 0)),
        width: width,
        height: height
      };
    }

    function textLayout(text) {
      const base = normalizedTextGeometry(text || {});
      const layouts = text?.layouts || {};
      return normalizedTextGeometry(layouts[language] || layouts.en || layouts.es || base, base);
    }

    function textScale(text) {
      const style = text.style || {};
      const basis = Math.max(1, Number(style.sizeBasis) || 1000);
      const targetWidth = stage.getBoundingClientRect().width || basis;
      return Math.max(0.15, targetWidth / basis);
    }

    function renderText(text, container, geometry, extraClass) {
      const element = document.createElement('div');
      element.className = 'cch-object cch-text' + (extraClass ? ' ' + extraClass : '');
      positionElement(element, geometry || textLayout(text));
      element.textContent = localizedValue(text.content);

      const style = text.style || {};
      const scale = textScale(text);
      const requestedFont = style.font || 'Garamond, Georgia, serif';
      const usesCafeteria = String(requestedFont).toLowerCase().includes('cafeteria');
      element.style.fontFamily = usesCafeteria ? '"cafeteria", sans-serif' : requestedFont;
      element.style.fontSize = ((Number(style.size) || 42) * scale) + 'px';
      element.style.fontWeight = usesCafeteria
        ? (Number(style.weight) >= 600 ? '700' : '400')
        : (style.weight || '400');
      element.style.fontStyle = style.italic ? 'italic' : 'normal';
      element.style.textDecoration = style.underline ? 'underline' : 'none';
      element.style.color = style.color || '#3b2a22';
      element.style.letterSpacing = ((Number(style.letterSpacing) || 0) * scale) + 'px';
      element.style.wordSpacing = ((Number(style.wordSpacing) || 0) * scale) + 'px';
      element.style.lineHeight = style.lineHeight || 1.2;
      element.style.textAlign = style.align || 'left';
      element.style.opacity = style.opacity ?? 1;
      element.style.padding = ((Number(style.padding) || 0) * scale) + 'px';
      element.style.borderRadius = ((Number(style.radius) || 0) * scale) + 'px';
      element.style.transform = 'rotate(' + (Number(style.rotation) || 0) + 'deg)';
      element.style.transformOrigin = 'center center';

      if (style.shadowEnabled) {
        element.style.textShadow =
          ((Number(style.shadowX) || 0) * scale) + 'px ' +
          ((Number(style.shadowY) || 0) * scale) + 'px ' +
          ((Number(style.shadowBlur) || 0) * scale) + 'px ' +
          (style.shadowColor || '#000000');
      }

      if ((Number(style.outlineWidth) || 0) > 0) {
        element.style.webkitTextStroke = ((Number(style.outlineWidth) || 0) * scale) + 'px ' + (style.outlineColor || '#ffffff');
        element.style.paintOrder = 'stroke fill';
      }

      if ((Number(style.backgroundOpacity) || 0) > 0) {
        element.style.background = hexToRgba(style.background || '#f9ecda', style.backgroundOpacity);
      }

      container.appendChild(element);
      return element;
    }

    function renderRevealText(text) {
      const element = renderText(text, stage, textLayout(text), 'cch-text--reveal');
      element.dataset.flapId = text.flapId || '';
      element.hidden = true;
    }

    function renderInsideText(text) {
      const flapButton = flapButtons.find(function (button) { return button.dataset.flapId === text.flapId; });
      const insideLive = flapButton?.querySelector('.cch-flap__inside-live-layer');
      const insideContent = flapButton?.querySelector('.cch-flap__inside-content');
      const flap = flapButton?._cchFlap;
      if (!(insideLive || insideContent) || !flap) return;
      renderText(text, insideLive || insideContent, orientInsideBox(textLayout(text), flap.insideOrientation), 'cch-text--inside');
    }

    function flapUsesSpreadArtwork(flap) {
      return flap && flap.frontSource === 'spread';
    }

    function appendSpreadCrop(container, source, flap) {
      if (!container || !source) return;
      const width = Math.max(0.01, Number(flap.width) || 1);
      const height = Math.max(0.01, Number(flap.height) || 1);
      const x = Number(flap.x) || 0;
      const y = Number(flap.y) || 0;
      const image = document.createElement('img');
      image.className = 'cch-flap__spread-crop';
      image.src = source;
      image.alt = '';
      image.draggable = false;
      image.style.width = (10000 / width) + '%';
      image.style.height = (10000 / height) + '%';
      image.style.left = (-100 * x / width) + '%';
      image.style.top = (-100 * y / height) + '%';
      container.appendChild(image);
    }

    function flapSourceName(flap) {
      return String(flap?.sourceFileName || flap?.frontImage || '').split('/').pop().toLowerCase();
    }

    function shouldKeepFlapCloseControl() {
      // Child testing showed that the full open-flap area is a better close
      // target than a small arrow, including flaps that extend off the page.
      return false;
    }

    function isGethsemaneFlap(spread, flap) {
      return String(spread?.id || '') === 'spread-04' &&
        flapSourceName(flap).endsWith('bk1-sprd-04-flap-01-front.png');
    }

    function renderFlap(flap, index) {
      const spread = book.spreads[spreadIndex];
      const keepsCloseControl = shouldKeepFlapCloseControl(spread, flap);
      const motionFlap = isGethsemaneFlap(spread, flap)
        ? Object.assign({}, flap, { openDirection: 'away' })
        : flap;
      const position = { x: flap.x || 0, y: flap.y || 0, width: flap.width || 10, height: flap.height || 10 };
      // Only this small teaching-page flap should settle on the Jesus artwork.
      // Its reveal asset path is unique even though the exported JSON contains
      // a duplicate flap ID elsewhere on the same spread.
      const revealOnlyJesusFlap = String(flap.revealImage || '')
        .toLowerCase()
        .endsWith('images/reveals/flap-04-02-reveal.webp');

      const reveal = document.createElement('span');
      reveal.className = 'cch-object cch-flap-reveal shape-' + (flap.shape || 'rectangle');
      positionElement(reveal, position);
      const revealSource = resolveAsset(flap.revealImage);
      let revealImage = null;
      if (revealSource) {
        revealImage = document.createElement('img');
        revealImage.className = 'cch-flap-reveal__image';
        revealImage.src = revealSource;
        revealImage.alt = '';
        revealImage.loading = 'eager';
        revealImage.decoding = 'async';
        reveal.appendChild(revealImage);
        if (typeof revealImage.decode === 'function') revealImage.decode().catch(function () {});
      }
      reveal.setAttribute('aria-hidden', 'true');
      stage.appendChild(reveal);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cch-object cch-flap shape-' + (flap.shape || 'rectangle');
      button.classList.add(keepsCloseControl ? 'cch-flap--has-close-control' : 'cch-flap--tap-to-close');
      if (revealOnlyJesusFlap) button.classList.add('cch-flap--reveal-only');
      button.dataset.flapId = flap.id || 'flap-' + index;
      button.dataset.bringFront = flap.bringToFront === false ? 'false' : 'true';
      button._cchFlap = flap;
      button.setAttribute('aria-label', localizedValue(flap.alt) || localizedValue(flap.label) || localized('Open flap', 'Abrir solapa'));
      positionElement(button, position);
      const configuredSpeed = Math.max(0.18, Number(flap.speed) || 0.38);
      const flapSpeed = spread.id === 'spread-08' && (flap.id === 'flap-08-01' || flap.id === 'flap-08-02')
        ? Math.min(configuredSpeed, 0.32)
        : Math.min(configuredSpeed, 0.38);
      button.style.setProperty('--speed', flapSpeed + 's');
      button.style.setProperty('--origin', flapTransformOrigin(flap));
      button.style.setProperty('--open-transform', flapTransform(motionFlap));
      button.style.setProperty('--inside-transform', flapInsideTransform(flap));
      button.style.setProperty('--inside-reflection', flapInsideReflection(flap));
      const shadowStrength = Math.max(0, Math.min(1, Number(flap.shadowStrength) || 0));
      button.style.setProperty('--front-outline-opacity', (shadowStrength * .72).toFixed(3));
      button.style.setProperty('--front-shadow-opacity', (shadowStrength * .52).toFixed(3));

      const card = document.createElement('span');
      card.className = 'cch-flap__card';
      const frontShadow = document.createElement('span');
      frontShadow.className = 'cch-flap__front-shadow';
      const frontShadowSource = document.createElement('span');
      frontShadowSource.className = 'cch-flap__front-shadow-source';
      const front = document.createElement('span');
      front.className = 'cch-flap__front';
      if (flapUsesSpreadArtwork(flap)) {
        const spreadSource = resolveAsset(localizedBackgroundSource(spread));
        appendSpreadCrop(frontShadowSource, spreadSource, flap);
        appendSpreadCrop(front, spreadSource, flap);
      } else {
        const frontSource = cssUrl(resolveAsset(flap.frontImage));
        frontShadowSource.style.backgroundImage = frontSource;
        front.style.backgroundImage = frontSource;
      }
      const inside = document.createElement('span');
      inside.className = 'cch-flap__inside';
      const insideShape = document.createElement('span');
      insideShape.className = 'cch-flap__inside-shape';
      const insideContent = document.createElement('span');
      insideContent.className = 'cch-flap__inside-content';
      const insideArt = document.createElement('span');
      insideArt.className = 'cch-flap__inside-art';
      insideArt.style.backgroundImage = cssUrl(resolveAsset(flap.insideImage));
      insideArt.style.transform = insideContentTransform(flap.insideOrientation);
      const insideLive = document.createElement('span');
      insideLive.className = 'cch-flap__inside-live-layer';
      insideContent.appendChild(insideArt);insideContent.appendChild(insideLive);insideShape.appendChild(insideContent);inside.appendChild(insideShape);
      frontShadow.appendChild(frontShadowSource);
      card.appendChild(frontShadow);card.appendChild(front);card.appendChild(inside);
      button.appendChild(card);stage.appendChild(button);

      const maskSource = resolveAsset(flap.frontImage);
      applyFlapShape([reveal, frontShadowSource, front], flap, index, maskSource);
      // Uploaded image-shaped inside art supplies its own alpha silhouette.
      // Reapplying the front mask after the back-face rotation can deform
      // asymmetric flaps in Safari.
      if (flap.shape !== 'image' || !flap.insideImage) {
        applyFlapShape([insideContent], flap, index, maskSource);
      }

      const hinge = flapHingePointOnSpread(flap);
      const closeButton = document.createElement('button');
      closeButton.type = 'button';closeButton.className = 'cch-flap-close';closeButton.hidden = true;
      closeButton.dataset.flapId = button.dataset.flapId;closeButton.textContent = '↩';
      closeButton.setAttribute('aria-label', localized('Close flap', 'Cerrar solapa'));
      closeButton.style.left = Math.max(3, Math.min(97, hinge.x)) + '%';
      closeButton.style.top = Math.max(4, Math.min(96, hinge.y)) + '%';
      const closeSize = flapCloseVisualSize(flap);
      closeButton.style.setProperty('--close-size', closeSize + 'px');
      closeButton.style.setProperty('--close-font-size', Math.max(11, Math.round(closeSize * .56)) + 'px');
      if (keepsCloseControl) stage.appendChild(closeButton);

      function openAfterRevealIsPainted() {
        if (!button.isConnected || !button.classList.contains('is-opening')) return;

        reveal.classList.add('is-visible');
        // Force Safari to commit the reveal at its final opacity before the
        // 3-D flap transform starts. Two frames are intentional here.
        void reveal.offsetWidth;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!button.isConnected || !button.classList.contains('is-opening')) return;
            button.classList.remove('is-opening');
            button.classList.add('is-open');
            window.clearTimeout(button._cchInsideTimer);
            if (!revealOnlyJesusFlap) {
              button._cchInsideTimer = window.setTimeout(function () {
                if (button.classList.contains('is-open')) button.classList.add('is-inside-visible');
              }, 35);
            }
            if (keepsCloseControl) closeButton.hidden = false;
            updateCoveredMirrors();
            updateHotspotVisibility();
          });
        });
      }

      function prepareRevealThenOpen() {
        if (!revealImage || (revealImage.complete && revealImage.naturalWidth > 0)) {
          openAfterRevealIsPainted();
          return;
        }

        let finished = false;
        const fallbackTimer = window.setTimeout(finish, 320);
        function finish() {
          if (finished) return;
          finished = true;
          window.clearTimeout(fallbackTimer);
          revealImage.removeEventListener('load', finish);
          revealImage.removeEventListener('error', finish);
          openAfterRevealIsPainted();
        }
        revealImage.addEventListener('load', finish, { once: true });
        revealImage.addEventListener('error', finish, { once: true });
      }

      function setOpen(opening) {
        if (opening) {
          button.classList.add('is-opening');
          closeButton.hidden = true;
          prepareRevealThenOpen();
          openedFlapIds.add(button.dataset.flapId);
          playBookSound('flapOpen');
          triggerHotspotForFlapOpen(button.dataset.flapId);
          window.setTimeout(resumeLeftNarrationGateIfReady, 120);
        } else {
          window.clearTimeout(button._cchInsideTimer);
          button.classList.remove('is-opening', 'is-open', 'is-inside-visible');
          reveal.classList.remove('is-visible');
          closeButton.hidden = true;
          updateCoveredMirrors();
          updateHotspotVisibility();
        }
        caption.textContent = opening ? localizedValue(flap.revealDescription) : '';
      }

      button.addEventListener('click', function (event) {
        if (event.target.closest('.cch-hotspot--inside')) return;
        if (button.classList.contains('is-opening')) return;
        if (button.classList.contains('is-open')) {
          if (!keepsCloseControl) setOpen(false);
          return;
        }
        setOpen(true);
      });
      closeButton.addEventListener('click', function (event) { event.stopPropagation();setOpen(false); });
      button._cchInsideContent = insideContent;
      button._cchCloseButton = closeButton;
      flapButtons.push(button);
    }

    function renderMirror(mirror, index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cch-object cch-mirror';
      button.dataset.mirrorIndex = String(index);
      button.dataset.coveredBy = mirror.coveredByFlapId || '';
      button.setAttribute('aria-label', localizedValue(mirror.alt) || localizedValue(mirror.label) || localized('Camera mirror', 'Espejo con cámara'));
      button.style.left = (mirror.x || 0) + '%';
      button.style.top = (mirror.y || 0) + '%';
      button.style.width = (mirror.size || 12) + '%';
      button.style.aspectRatio = '1 / 1';

      button.addEventListener('click', async function () {
        caption.textContent = localizedValue(mirror.alt);
        if (cameraMode === 'live' && cameraStream) return;
        await enableCameraMirrors();
      });

      stage.appendChild(button);
      mirrorButtons.push({ button: button, mirror: mirror });
      renderMirrorContent(button, mirror);
    }

    function renderMirrors() {
      mirrorButtons.forEach(function (entry) {
        renderMirrorContent(entry.button, entry.mirror);
      });
      updateCoveredMirrors();
    }

    function mirrorFallbackSource(mirror) {
      return localizedValue(mirror.fallbackImages) || mirror.fallbackImage || '';
    }

    function mirrorPrompt(mirror) {
      return localizedValue(mirror.prompt) || localized('Tap to turn on camera', 'Toca para activar la cámara');
    }

    function renderMirrorContent(button, mirror) {
      button.replaceChildren();
      button.dataset.cameraMode = cameraMode;
      if (cameraMode === 'live' && cameraStream) {
        const video = document.createElement('video');
        video.autoplay = true;video.playsInline = true;video.muted = true;video.srcObject = cameraStream;
        button.appendChild(video);video.play().catch(function () {});return;
      }
      if (cameraMode === 'fallback') {
        const source = resolveAsset(mirrorFallbackSource(mirror));
        if (source) { const image = document.createElement('img');image.src = source;image.alt = '';button.appendChild(image); }
        return;
      }
      if (cameraMode === 'off') return;
      if (cameraMode === 'pending') {
        const label = document.createElement('span');label.className = 'cch-mirror__pending-label';
        label.textContent = localized('Mirror', 'Espejo');button.appendChild(label);return;
      }
      const prompt = document.createElement('span');
      prompt.className = 'cch-mirror__prompt';prompt.textContent = mirrorPrompt(mirror);button.appendChild(prompt);
    }

    async function enableCameraMirrors() {
      if (cameraStream) {
        cameraMode = 'live';
        renderMirrors();
        return true;
      }
      try {
        cameraStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false });
        cameraMode = 'live';
        stopCameraButton.hidden = false;
        renderMirrors();syncCameraModeSelect();
        clearNotice();
        return true;
      } catch (error) {
        console.warn(error);
        cameraMode = 'fallback';
        renderMirrors();syncCameraModeSelect();
        showNotice(localized(
          'Camera access was unavailable, so illustrated mirrors are being used.',
          'La cámara no está disponible, así que se usan los espejos ilustrados.'
        ));
        return false;
      }
    }

    function syncCameraModeSelect() {
      cameraModeSelect.value = cameraPreference;
    }
    function closeParentSettings() {
      if (settingsPanel.hidden) return;
      settingsPanel.hidden = true;
      settingsButton.setAttribute('aria-expanded', 'false');
    }
    function currentSpreadHasNarration() {
      const spread = book?.spreads?.[spreadIndex];
      return (spread?.audioClips || []).some(function (clip) {
        return Boolean(localizedAudioSource(clip));
      });
    }
    function syncNarrationButton() {
      if (!playButton) return;
      const available = Boolean(audioEnabled && book && currentSpreadHasNarration());
      root.classList.toggle('cch-narration-unavailable', !available);
      playButton.hidden = !available;
      playButton.disabled = !available;
      playButton.setAttribute('aria-hidden', available ? 'false' : 'true');
      playButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      const label = playButton.classList.contains('is-playing')
        ? localized('Pause page narration', 'Pausar la narración de la página')
        : playButton.classList.contains('is-paused')
          ? localized('Resume page narration', 'Reanudar la narración de la página')
          : localized('Read this page aloud', 'Leer esta página en voz alta');
      playButton.setAttribute('aria-label', label);
    }
    function applyAudioPreference() {
      audioModeSelect.value = audioEnabled ? 'on' : 'off';
      root.classList.toggle('cch-audio-is-off', !audioEnabled);
      syncNarrationButton();
      if (!audioEnabled) {
        stopNarration();
        if (soundEffectAudio) {
          soundEffectAudio.pause();
          soundEffectAudio.currentTime = 0;
          soundEffectAudio = null;
        }
      }
    }
    function useIllustratedMirrors() {
      stopCamera('fallback');renderMirrors();syncCameraModeSelect();
    }
    function turnCameraMirrorsOff() {
      stopCamera('off');renderMirrors();syncCameraModeSelect();
    }

    function closeCameraChoice() {
      if (cameraChoicePanel) cameraChoicePanel.remove();
      cameraChoicePanel = null;
    }

    function showCameraChoice() {
      closeCameraChoice();
      return new Promise(function (resolve) {
        const panel = document.createElement('div');
        panel.className = 'cch-camera-choice';panel.setAttribute('role', 'dialog');panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', localized('Choose mirror type', 'Elige el tipo de espejo'));
        panel.innerHTML = '<div class="cch-camera-choice__card"><h2>' + localized('Choose the mirrors', 'Elige los espejos') + '</h2><p>' + localized('Choose whether this book uses live camera mirrors, illustrated mirrors, or no mirror feature.', 'Elige si este libro usa espejos con cámara, espejos ilustrados o ningún espejo.') + '</p><label class="cch-camera-choice__select-label">' + localized('Mirror setting', 'Configuración del espejo') + '<select data-cch-camera-choice-select><option value="live">' + localized('Camera: Enable camera mirrors', 'Cámara: Activar espejos con cámara') + '</option><option value="fallback">' + localized('Camera: Use illustrated mirrors', 'Cámara: Usar espejos ilustrados') + '</option><option value="off">' + localized('Camera: Off', 'Cámara: Apagada') + '</option></select></label><button type="button" data-cch-camera-continue>' + localized('Continue', 'Continuar') + '</button></div>';
        root.appendChild(panel);cameraChoicePanel = panel;
        const select = panel.querySelector('[data-cch-camera-choice-select]');select.value = 'live';
        panel.querySelector('[data-cch-camera-continue]').addEventListener('click', async function () {
          cameraPreference = select.value;
          safelySaveCameraPreference(cameraPreference);
          if (select.value === 'live') await enableCameraMirrors();
          else if (select.value === 'fallback') useIllustratedMirrors();
          else turnCameraMirrorsOff();
          closeCameraChoice();syncCameraModeSelect();resolve(cameraMode);
        });
        select.focus({ preventScroll: true });
      });
    }

    function hotspotPlacement(hotspot) {
      return ['spread', 'reveal', 'inside'].includes(hotspot?.placement) ? hotspot.placement : 'spread';
    }

    function hotspotTrigger(hotspot) {
      return hotspot && hotspot.trigger === 'flapOpen' ? 'flapOpen' : 'tap';
    }

    function triggerHotspotForFlapOpen(flapId) {
      const hotspot = (book?.spreads?.[spreadIndex]?.hotspots || []).find(function (item) {
        return hotspotPlacement(item) === 'reveal' && item.flapId === flapId && hotspotTrigger(item) === 'flapOpen';
      });
      if (!hotspot) return;
      window.setTimeout(function () { activateHotspot(hotspot); }, 80);
    }

    function activateHotspot(hotspot, event) {
      if (event) event.stopPropagation();
      const hotspotCaption = localizedValue(hotspot.caption) || localizedValue(hotspot.label);
      const source = localizedAudioSource(hotspot.audio);
      if (source) playHotspotAudio(resolveAsset(source), hotspotCaption);
      else caption.textContent = hotspotCaption;
    }

    function prepareHotspotElement(element, hotspot) {
      element.setAttribute('aria-label', localizedValue(hotspot.alt) || localizedValue(hotspot.label) || localized('Play audio', 'Reproducir audio'));
      element.addEventListener('click', function (event) { activateHotspot(hotspot, event); });
      element.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateHotspot(hotspot, event);
        }
      });
    }

    function renderHotspot(hotspot) {
      const placement = hotspotPlacement(hotspot);
      if (placement === 'inside') {
        const flap = flapButtons.find(function (button) { return button.dataset.flapId === hotspot.flapId; });
        const inside = flap?.querySelector('.cch-flap__inside-live-layer') || flap?.querySelector('.cch-flap__inside-content');
        if (!inside) return;
        const element = document.createElement('span');
        element.className = 'cch-hotspot cch-hotspot--inside';
        element.setAttribute('role', 'button');
        element.tabIndex = 0;
        const box = orientInsideBox(hotspot, flap?._cchFlap?.insideOrientation);
        element.style.left = box.x + '%';
        element.style.top = box.y + '%';
        element.style.width = box.width + '%';
        element.style.height = box.height + '%';
        prepareHotspotElement(element, hotspot);
        inside.appendChild(element);
        hotspotButtons.push({ button: element, hotspot: hotspot, placement: placement });
        return;
      }

      if (placement === 'reveal' && hotspotTrigger(hotspot) === 'flapOpen') return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cch-object cch-hotspot' + (placement === 'reveal' ? ' cch-hotspot--reveal' : '');
      button.dataset.flapId = hotspot.flapId || '';
      positionElement(button, hotspot);
      prepareHotspotElement(button, hotspot);
      stage.appendChild(button);
      hotspotButtons.push({ button: button, hotspot: hotspot, placement: placement });
    }

    function updateHotspotVisibility() {
      hotspotButtons.forEach(function (entry) {
        if (entry.placement !== 'reveal') return;
        const coveringFlap = flapButtons.find(function (button) { return button.dataset.flapId === (entry.hotspot.flapId || ''); });
        const available = Boolean(coveringFlap && coveringFlap.classList.contains('is-open'));
        entry.button.hidden = !available;entry.button.setAttribute('aria-hidden', available ? 'false' : 'true');
      });
      stage.querySelectorAll('.cch-text--reveal').forEach(function (element) {
        const coveringFlap = flapButtons.find(function (button) { return button.dataset.flapId === (element.dataset.flapId || ''); });
        const available = Boolean(coveringFlap && coveringFlap.classList.contains('is-open'));
        element.hidden = !available;element.setAttribute('aria-hidden', available ? 'false' : 'true');
      });
    }

    function updateCoveredMirrors() {
      mirrorButtons.forEach(function (entry) {
        const coveringFlapId = entry.button.dataset.coveredBy;
        if (!coveringFlapId) {
          entry.button.hidden = false;
          return;
        }

        const coveringFlap = flapButtons.find(function (button) {
          return button.dataset.flapId === coveringFlapId;
        });
        entry.button.hidden = Boolean(coveringFlap && !coveringFlap.classList.contains('is-open'));
      });
    }

    function applyFlapShape(elements, flap, index, maskSource) {
      const shape = flap.shape || 'rectangle';

      if (shape === 'rounded') {
        const radius = Math.max(0, Math.min(50, flap.radius ?? 18));
        elements.forEach(function (element) {
          element.style.borderRadius = radius + '%';
        });
        return;
      }

      if (shape === 'ellipse') {
        elements.forEach(function (element) {
          element.style.borderRadius = '50%';
        });
        return;
      }

      if (shape === 'image' && maskSource) {
        elements.forEach(function (element) {
          const mask = cssUrl(maskSource);
          element.style.webkitMaskImage = mask;
          element.style.maskImage = mask;
          element.style.webkitMaskSize = '100% 100%';
          element.style.maskSize = '100% 100%';
          element.style.webkitMaskRepeat = 'no-repeat';
          element.style.maskRepeat = 'no-repeat';
          element.style.webkitMaskPosition = 'center';
          element.style.maskPosition = 'center';
        });
        return;
      }

      if (shape === 'polygon' && Array.isArray(flap.points) && flap.points.length > 2) {
        const polygon = 'polygon(' + flap.points.map(function (point) {
          return point.x + '% ' + point.y + '%';
        }).join(', ') + ')';
        elements.forEach(function (element) {
          element.style.clipPath = polygon;
        });
        return;
      }

      if (shape === 'freeform' && Array.isArray(flap.points) && flap.points.length > 2) {
        const clipId = root.id + '-clip-' + spreadIndex + '-' + index;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('cch-clip-defs');
        svg.setAttribute('aria-hidden', 'true');

        const defs = document.createElementNS(svg.namespaceURI, 'defs');
        const clipPath = document.createElementNS(svg.namespaceURI, 'clipPath');
        clipPath.id = clipId;
        clipPath.setAttribute('clipPathUnits', 'objectBoundingBox');

        const path = document.createElementNS(svg.namespaceURI, 'path');
        path.setAttribute('d', smoothNormalizedPath(flap.points));

        clipPath.appendChild(path);
        defs.appendChild(clipPath);
        svg.appendChild(defs);
        stage.appendChild(svg);

        elements.forEach(function (element) {
          element.style.clipPath = 'url(#' + clipId + ')';
        });
      }
    }

    function smoothNormalizedPath(points) {
      const normalized = points.map(function (point) {
        return { x: point.x / 100, y: point.y / 100 };
      });
      const midpoint = function (a, b) {
        return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      };
      const start = midpoint(normalized[normalized.length - 1], normalized[0]);
      let path = 'M ' + start.x.toFixed(5) + ' ' + start.y.toFixed(5);

      normalized.forEach(function (point, index) {
        const next = normalized[(index + 1) % normalized.length];
        const middle = midpoint(point, next);
        path += ' Q ' + point.x.toFixed(5) + ' ' + point.y.toFixed(5) + ' ' + middle.x.toFixed(5) + ' ' + middle.y.toFixed(5);
      });

      return path + ' Z';
    }

    function scheduleNarration(delay) {
      if (!audioEnabled) return;
      clearTimeout(narrationTimer);
      narrationTimer = window.setTimeout(function () {
        narrationTimer = null;
        playCurrentNarration(false);
      }, delay);
    }

    function narrationItemsForSpread(spread) {
      return (spread.audioClips || []).map(function (clip) {
        return {
          source: resolveAsset(localizedAudioSource(clip)),
          pageSide: ['left', 'right', 'full'].includes(clip.pageSide) ? clip.pageSide : 'full'
        };
      }).filter(function (item) { return Boolean(item.source); });
    }

    function flapNarrationPage(flap) {
      const manual = ['left', 'right', 'ignore'].includes(flap?.narrationPage) ? flap.narrationPage : 'auto';
      if (manual !== 'auto') return manual;
      return (Number(flap?.x) || 0) + (Number(flap?.width) || 0) / 2 < 50 ? 'left' : 'right';
    }

    function leftPageFlaps() {
      const spread = book?.spreads?.[spreadIndex];
      return (spread?.flaps || []).filter(function (flap) {
        return flapNarrationPage(flap) === 'left';
      });
    }

    function allLeftPageFlapsOpen() {
      const required = leftPageFlaps();
      if (!required.length) return true;
      return required.every(function (flap) { return openedFlapIds.has(flap.id); });
    }

    function shouldWaitForLeftFlaps(item) {
      return book?.settings?.gateRightNarrationUntilLeftFlaps !== false && item.pageSide === 'right' && !allLeftPageFlapsOpen();
    }

    function waitForLeftFlaps(token) {
      narrationWaitingForLeftFlaps = true;
      return new Promise(function (resolve) {
        leftGateResolve = function () {
          leftGateResolve = null;
          narrationWaitingForLeftFlaps = false;
          resolve(token === narrationToken);
        };
      });
    }

    function resumeLeftNarrationGateIfReady() {
      if (!leftGateResolve || !narrationWaitingForLeftFlaps) return;
      if (!allLeftPageFlapsOpen() || hotspotAudio) return;
      leftGateResolve();
    }

    function pauseNarrationByUser() {
      if (!audioEnabled || !playButton.classList.contains('is-playing')) return;
      narrationUserPaused = true;
      if (narrationAudio && !narrationAudio.paused) narrationAudio.pause();
      playButton.classList.remove('is-playing');
      playButton.classList.add('is-paused');
      syncNarrationButton();
    }

    function resumeNarrationByUser() {
      if (!audioEnabled || !narrationUserPaused) return;
      narrationUserPaused = false;
      playButton.classList.remove('is-paused');
      playButton.classList.add('is-playing');
      const release = narrationResumeResolve;
      narrationResumeResolve = null;
      if (release) release();
      if (narrationAudio && narrationAudio.paused) {
        narrationAudio.play().catch(function () {
          stopNarration();
          showNotice(localized(
            'Narration could not resume. Tap the speaker button to try again.',
            'La narración no se pudo reanudar. Toca el botón del altavoz para intentarlo de nuevo.'
          ));
        });
      }
      syncNarrationButton();
    }

    function waitForUserNarrationResume(token) {
      if (!narrationUserPaused) return Promise.resolve(token === narrationToken);
      return new Promise(function (resolve) {
        narrationResumeResolve = function () { resolve(token === narrationToken); };
      });
    }

    function playCurrentNarration(showFailure) {
      if (!book || !audioEnabled) return;
      const items = narrationItemsForSpread(book.spreads[spreadIndex]);
      if (items.length === 0) {
        if (showFailure) showNotice(localized('No narration file is connected to this spread.', 'No hay narración conectada a esta página.'));
        return;
      }
      playNarrationSources(items, showFailure);
    }

    async function playNarrationSources(items, showFailure) {
      stopNarration();
      const token = ++narrationToken;
      narrationUserPaused = false;
      playButton.classList.remove('is-paused');
      playButton.classList.add('is-playing');
      syncNarrationButton();

      for (const item of items) {
        if (token !== narrationToken) break;
        const canContinue = await waitForUserNarrationResume(token);
        if (!canContinue || token !== narrationToken) break;
        if (shouldWaitForLeftFlaps(item)) {
          const stillCurrent = await waitForLeftFlaps(token);
          if (!stillCurrent || token !== narrationToken) break;
          const resumedAfterGate = await waitForUserNarrationResume(token);
          if (!resumedAfterGate || token !== narrationToken) break;
        }
        try {
          await playOneNarration(item.source, token);
        } catch (error) {
          console.warn(error);
          if (showFailure || error?.name === 'NotAllowedError') {
            showNotice(localized(
              'Narration was blocked or could not load. Tap the speaker button to try again.',
              'La narración fue bloqueada o no se pudo cargar. Toca el botón del altavoz para intentarlo de nuevo.'
            ));
          }
          break;
        }
      }

      if (token === narrationToken) {
        narrationUserPaused = false;
        narrationResumeResolve = null;
        playButton.classList.remove('is-playing', 'is-paused');
        syncNarrationButton();
      }
    }

    function playOneNarration(source, token) {
      return new Promise(function (resolve, reject) {
        narrationAudio = new Audio(source);
        narrationAudio.preload = 'auto';
        narrationAudio.addEventListener('ended', resolve, { once: true });
        narrationAudio.addEventListener('error', function () { reject(new Error('Narration audio failed to load.')); }, { once: true });
        const playPromise = narrationAudio.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(reject);
        if (token !== narrationToken) { narrationAudio.pause();resolve(); }
      });
    }

    function pauseNarrationForHotspot() {
      if (narrationTimer) {
        clearTimeout(narrationTimer);narrationTimer = null;
        pendingNarrationAfterHotspot = true;narrationPausedForHotspot = true;
        return true;
      }
      if (narrationWaitingForLeftFlaps) {
        narrationPausedForHotspot = true;
        return true;
      }
      if (narrationAudio && !narrationAudio.paused) {
        narrationAudio.pause();narrationPausedForHotspot = true;
        return true;
      }
      return narrationPausedForHotspot;
    }

    function resumeNarrationAfterHotspot() {
      if (narrationUserPaused) return;
      if (!narrationPausedForHotspot) {
        resumeLeftNarrationGateIfReady();
        return;
      }
      narrationPausedForHotspot = false;
      if (pendingNarrationAfterHotspot) {
        pendingNarrationAfterHotspot = false;
        window.setTimeout(function () { playCurrentNarration(false); }, 80);
        return;
      }
      if (narrationWaitingForLeftFlaps) {
        resumeLeftNarrationGateIfReady();
        return;
      }
      if (narrationAudio) narrationAudio.play().catch(function () { stopNarration(); });
    }

    function stopHotspotAudio(resumeNarration) {
      hotspotAudioQueue = [];
      hotspotAudioSource = '';
      if (hotspotAudio) {
        hotspotAudio.pause();hotspotAudio.currentTime = 0;hotspotAudio = null;
      }
      if (resumeNarration) resumeNarrationAfterHotspot();
    }

    function startHotspotAudio(item) {
      if (!item?.source || !audioEnabled) return;
      if (item.caption) caption.textContent = item.caption;
      const audio = new Audio(item.source);
      hotspotAudio = audio;
      hotspotAudioSource = item.source;
      const finish = function () {
        if (hotspotAudio !== audio) return;
        hotspotAudio = null;
        hotspotAudioSource = '';
        const next = hotspotAudioQueue.shift();
        if (next) {
          startHotspotAudio(next);
          return;
        }
        resumeNarrationAfterHotspot();
      };
      audio.addEventListener('ended', finish, { once: true });
      audio.addEventListener('error', finish, { once: true });
      audio.play().catch(function () {
        finish();
        showNotice(localized('This hotspot audio could not play.', 'El audio de este punto interactivo no se pudo reproducir.'));
      });
    }

    function playHotspotAudio(source, hotspotCaption) {
      if (!source || !audioEnabled) return;
      const item = { source: source, caption: hotspotCaption || '' };
      if (hotspotAudio) {
        const duplicate = hotspotAudioSource === source || hotspotAudioQueue.some(function (queued) { return queued.source === source; });
        if (!duplicate) hotspotAudioQueue.push(item);
        return;
      }
      pauseNarrationForHotspot();
      startHotspotAudio(item);
    }

    function playBookSound(soundName) {
      if (!audioEnabled) return;
      const path = book?.sounds?.[soundName]?.path || '';
      const source = resolveAsset(path);
      if (!source) return;

      if (soundEffectAudio) {
        soundEffectAudio.pause();
        soundEffectAudio.currentTime = 0;
      }

      soundEffectAudio = new Audio(source);
      soundEffectAudio.volume = 0.82;
      soundEffectAudio.play().catch(function () {
        soundEffectAudio = null;
      });
    }

    function stopNarration() {
      clearTimeout(narrationTimer);
      narrationTimer = null;
      pendingNarrationAfterHotspot = false;
      narrationPausedForHotspot = false;
      narrationUserPaused = false;
      const releaseNarrationPause = narrationResumeResolve;
      narrationResumeResolve = null;
      if (releaseNarrationPause) releaseNarrationPause();
      stopHotspotAudio(false);
      narrationToken += 1;
      narrationWaitingForLeftFlaps = false;
      if (leftGateResolve) { const release = leftGateResolve; leftGateResolve = null; release(); }

      if (narrationAudio) {
        narrationAudio.pause();
        narrationAudio.currentTime = 0;
        narrationAudio = null;
      }

      playButton.classList.remove('is-playing', 'is-paused');
      syncNarrationButton();
    }

    function stopCamera(nextMode) {
      if (cameraStream) {
        cameraStream.getTracks().forEach(function (track) { track.stop(); });
        cameraStream = null;
      }
      cameraMode = nextMode || 'pending';
      if (stopCameraButton) stopCameraButton.hidden = cameraMode !== 'live';
    }

    function stopAllMedia() {
      stopNarration();
      if (soundEffectAudio) {
        soundEffectAudio.pause();
        soundEffectAudio = null;
      }
      stopCamera('pending');
      closeCameraChoice();
    }

    function updateReaderControls() {
      const isLast = spreadIndex === book.spreads.length - 1;
      const bookTitle = localizedValue(book.title);

      positionLabel.textContent = isLast
        ? localized('Back Cover', 'Contraportada') + ' · ' + (spreadIndex + 1) + ' / ' + book.spreads.length
        : bookTitle + ' · ' + (spreadIndex + 1) + ' / ' + book.spreads.length;

      previousButton.disabled = spreadIndex === 0;
      nextButton.disabled = isLast;
      previousButton.setAttribute('aria-label', localized('Previous spread', 'Página anterior'));
      nextButton.setAttribute('aria-label', localized('Next spread', 'Página siguiente'));
      if (returnLibraryButton) returnLibraryButton.setAttribute('aria-label', localized('Return to library', 'Volver a la biblioteca'));
    }

    function applyLanguage(nextLanguage) {
      settingsLanguageSelect.value = nextLanguage;
      updateCameraModeSelectLabels();
      updateParentSettingsLabels();
      root.querySelectorAll('[data-cch-text]').forEach(function (element) {
        element.hidden = element.dataset.cchText !== nextLanguage;
      });

      languageButtons.forEach(function (button) {
        const selected = button.dataset.cchLanguage === nextLanguage;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      syncNarrationButton();
    }

    function updateParentSettingsLabels() {
      const spanish = language === 'es';
      settingsButton.setAttribute('aria-label', spanish ? 'Configuración para padres' : 'Parent settings');
      settingsPanel.setAttribute('aria-label', spanish ? 'Configuración para padres' : 'Parent settings');
      settingsTitle.textContent = spanish ? 'Configuración para padres' : 'Parent settings';
      languageLabelText.textContent = spanish ? 'Idioma' : 'Language';
      cameraLabelText.textContent = spanish ? 'Espejos' : 'Mirrors';
      audioLabelText.textContent = spanish ? 'Audio' : 'Audio';
      accountText.textContent = customerLoggedIn
        ? (spanish ? 'Cuenta iniciada' : 'Signed in')
        : (spanish ? 'Acceso a libros comprados' : 'Purchased-book access');
      accountLink.hidden = customerLoggedIn;
      accountLink.textContent = spanish ? 'Iniciar sesión' : 'Sign in';
      settingsClose.textContent = spanish ? 'Cerrar' : 'Close';
      audioModeSelect.options[0].textContent = spanish ? 'Audio activado' : 'Audio on';
      audioModeSelect.options[1].textContent = spanish ? 'Audio desactivado' : 'Audio off';
    }

    function updateCameraModeSelectLabels() {
      if (!cameraModeSelect) return;
      const labels = language === 'es'
        ? { pending:'Preguntar al abrir un libro',live:'Activar espejos con cámara',fallback:'Usar espejos ilustrados',off:'Apagar los espejos' }
        : { pending:'Ask when a book opens',live:'Enable camera mirrors',fallback:'Use illustrated mirrors',off:'Turn mirrors off' };
      Array.from(cameraModeSelect.options).forEach(function (option) { option.textContent = labels[option.value] || option.textContent; });
    }

    function localizedBackgroundSource(spread) {
      const backgrounds = spread?.backgrounds || {};
      return backgrounds[language] || backgrounds.en || spread?.background || spread?.backgroundPath || '';
    }

    function fontFormat(path) {
      const clean = String(path || '').split(/[?#]/)[0].toLowerCase();
      if (clean.endsWith('.woff2')) return 'woff2';
      if (clean.endsWith('.woff')) return 'woff';
      if (clean.endsWith('.otf')) return 'opentype';
      if (clean.endsWith('.ttf')) return 'truetype';
      return '';
    }

    function installBookFonts() {
      // Cafeteria is loaded from the Adobe Fonts web project automatically.
      // Remove any older reader-created local @font-face rules so missing
      // Shopify font files cannot override the working Adobe font family.
      ensureCafeteriaAdobeKit();
      const oldStyle = document.getElementById(root.id + '-book-fonts');
      if (oldStyle) oldStyle.remove();
    }

    function localizedValue(value) {
      if (typeof value === 'string') return value;
      if (!value || typeof value !== 'object') return '';
      return value[language] || value.en || value.es || '';
    }

    function localizedAudioSource(value) {
      if (!value || typeof value !== 'object') return '';
      return value[language] || value.en || value.es || '';
    }

    function localized(english, spanish) {
      return language === 'es' ? spanish : english;
    }

    function resolveAsset(path) {
      return resolveAssetForBook(path, book, bookUrl);
    }

    function resolveAssetForBook(path, sourceBook, sourceUrl) {
      if (!path) return '';
      if (/^(data:|blob:|https?:|\/\/)/i.test(path)) return path;

      const cleanPath = String(path).replace(/^\.\//, '').replace(/^\//, '');
      const flatten = root.dataset.cchFlattenAssets !== 'false';
      const filePath = flatten ? cleanPath.split('/').pop() : cleanPath;
      const configuredBase = root.dataset.cchAssetBase || sourceBook?.assetBaseUrl || sourceBook?.baseUrl || '';

      if (configuredBase) {
        const baseUrl = new URL(ensureTrailingSlash(configuredBase), window.location.href);
        return new URL(filePath, baseUrl).href;
      }

      if (sourceBook?.basePath && !flatten) {
        return new URL(ensureTrailingSlash(sourceBook.basePath) + filePath, sourceUrl || window.location.href).href;
      }

      return new URL(filePath, sourceUrl || window.location.href).href;
    }

    function ensureTrailingSlash(value) {
      return value.endsWith('/') ? value : value + '/';
    }

    function positionElement(element, object) {
      element.style.left = (object.x || 0) + '%';
      element.style.top = (object.y || 0) + '%';
      element.style.width = (object.width || 0) + '%';
      element.style.height = (object.height || 0) + '%';
    }

    function normalizedHingeMode(flap) { return flap?.hingeMode === 'custom' ? 'custom' : 'edge'; }
    function flapHingeAngle(flap) {
      if (normalizedHingeMode(flap) === 'custom') return Number(flap?.hingeAngle) || 0;
      return flap?.hinge === 'left' || flap?.hinge === 'right' ? 90 : 0;
    }
    function flapAxis(flap) {
      const radians = flapHingeAngle(flap) * Math.PI / 180;
      return { x: Math.cos(radians), y: Math.sin(radians) };
    }
    function flapLocalHingePoint(flap) {
      if (normalizedHingeMode(flap) === 'custom') return {
        x: Math.max(0, Math.min(100, Number(flap?.hingePointX) || 0)),
        y: Math.max(0, Math.min(100, Number(flap?.hingePointY) || 0))
      };
      const amount = Math.max(0, Math.min(45, Number(flap?.hingeInset) || 0));
      if (flap?.hinge === 'left') return { x: amount, y: 50 };
      if (flap?.hinge === 'right') return { x: 100 - amount, y: 50 };
      if (flap?.hinge === 'bottom') return { x: 50, y: 100 - amount };
      return { x: 50, y: amount };
    }
    function flapTransformOrigin(flap) {
      const point = flapLocalHingePoint(flap);
      return point.x + '% ' + point.y + '%';
    }
    function flapTowardSign(flap) {
      const axis = flapAxis(flap), point = flapLocalHingePoint(flap);
      const rx = .5 - point.x / 100, ry = .5 - point.y / 100;
      const cross = axis.x * ry - axis.y * rx;
      return Math.abs(cross) < 1e-6 ? 1 : (cross > 0 ? 1 : -1);
    }
    function flapTransform(flap) {
      const openAngle = Math.max(110, Math.min(180, Number(flap.openAngle) || 180));
      const toward = flapTowardSign(flap);
      const angle = (flap.openDirection === 'away' ? -toward : toward) * openAngle;
      if (normalizedHingeMode(flap) === 'custom') {
        const axis = flapAxis(flap);
        return 'rotate3d(' + axis.x.toFixed(6) + ',' + axis.y.toFixed(6) + ',0,' + angle + 'deg) translateZ(2px)';
      }
      return flap.hinge === 'left' || flap.hinge === 'right' ? 'rotateY(' + angle + 'deg) translateZ(2px)' : 'rotateX(' + angle + 'deg) translateZ(2px)';
    }
    function flapInsideTransform(flap) {
      if (normalizedHingeMode(flap) === 'custom') {
        const axis = flapAxis(flap);
        return 'rotate3d(' + axis.x.toFixed(6) + ',' + axis.y.toFixed(6) + ',0,180deg)';
      }
      return flap.hinge === 'left' || flap.hinge === 'right' ? 'rotateY(180deg)' : 'rotateX(180deg)';
    }
    function flapInsideReflection(flap) {
      const angle = flapHingeAngle(flap);
      return 'rotate(' + angle + 'deg) scaleY(-1) rotate(' + (-angle) + 'deg)';
    }
    function flapHingePointOnSpread(flap) {
      const local = flapLocalHingePoint(flap);
      return {
        x: (Number(flap?.x) || 0) + (Number(flap?.width) || 0) * local.x / 100,
        y: (Number(flap?.y) || 0) + (Number(flap?.height) || 0) * local.y / 100
      };
    }
    function flapCloseVisualSize(flap) {
      const shortest = Math.max(0, Math.min(Number(flap?.width) || 0, Number(flap?.height) || 0));
      if (shortest <= 5.5) return 18;
      if (shortest <= 8) return 21;
      if (shortest <= 12) return 25;
      if (shortest <= 18) return 30;
      return 36;
    }

    function normalizeInsideOrientation(value) {
      return ['asUploaded', 'rotate180', 'flipHorizontal', 'flipVertical'].includes(value) ? value : 'asUploaded';
    }

    function orientInsideBox(object, orientation) {
      const box = { x: Number(object.x) || 0, y: Number(object.y) || 0, width: Number(object.width) || 0, height: Number(object.height) || 0 };
      switch (normalizeInsideOrientation(orientation)) {
        case 'rotate180': return { x: 100 - box.x - box.width, y: 100 - box.y - box.height, width: box.width, height: box.height };
        case 'flipHorizontal': return { x: 100 - box.x - box.width, y: box.y, width: box.width, height: box.height };
        case 'flipVertical': return { x: box.x, y: 100 - box.y - box.height, width: box.width, height: box.height };
        default: return box;
      }
    }

    function insideContentTransform(orientation) {
      switch (normalizeInsideOrientation(orientation)) {
        case 'rotate180': return 'rotate(180deg)';
        case 'flipHorizontal': return 'scaleX(-1)';
        case 'flipVertical': return 'scaleY(-1)';
        default: return 'none';
      }
    }

    function cssUrl(value) {
      if (!value) return 'none';
      return 'url("' + String(value).replace(/"/g, '\\"') + '")';
    }

    function hexToRgba(hex, alpha) {
      const clean = String(hex || '#f9ecda').replace('#', '');
      const normalized = clean.length === 3
        ? clean.split('').map(function (character) { return character + character; }).join('')
        : clean;
      const number = parseInt(normalized, 16);
      const red = (number >> 16) & 255;
      const green = (number >> 8) & 255;
      const blue = number & 255;
      return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
    }

    function showNotice(message) {
      notice.textContent = message;
      notice.hidden = !message;
    }

    function clearNotice() {
      showNotice('');
    }
  }

  function safelyReadLanguage() {
    try {
      return sessionStorage.getItem('cch-language') || 'en';
    } catch (error) {
      return 'en';
    }
  }

  function safelySaveLanguage(language) {
    try {
      sessionStorage.setItem('cch-language', language);
    } catch (error) {
      // The reader still works when storage is unavailable.
    }
  }

  function safelyReadCameraPreference() {
    try {
      const value = localStorage.getItem('cch-camera-preference') || 'pending';
      return ['pending', 'live', 'fallback', 'off'].includes(value) ? value : 'pending';
    } catch (error) {
      return 'pending';
    }
  }

  function safelySaveCameraPreference(value) {
    try { localStorage.setItem('cch-camera-preference', value); }
    catch (error) { /* The reader still works without storage. */ }
  }

  function safelyReadAudioPreference() {
    try { return localStorage.getItem('cch-audio-enabled') !== 'false'; }
    catch (error) { return true; }
  }

  function safelySaveAudioPreference(enabled) {
    try { localStorage.setItem('cch-audio-enabled', enabled ? 'true' : 'false'); }
    catch (error) { /* The reader still works without storage. */ }
  }
})();




















































































